import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { CustomFieldDefinition } from 'app/core/models/essette-api';



@autoinject()
export class MemberCustomFieldDefinition extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected code: string | null = null;

    protected isThisCustomFieldDefinition: (definition: CustomFieldDefinition) => boolean =
        (definition: CustomFieldDefinition) => {
            return definition.code === this.code;
        };



    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
        this.logger.source = this;
    }


    protected async activate(params: any): Promise<void> {
        this.code = params;
    }

    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////

    protected getProperty(code: string) {
        const property = [code];
        if(/lookup/i.test(code)) {
            property.push('description');
        }
        return property.join('.');
    }

    ////****************** Service Calls ********************************************////

}
